export const get = (state, { id }) => (state.ui.dictionary[id] ? state.ui.dictionary[id] : null);
